import { dscvrIcApi } from '@/shared/api';
import { useQuery } from '@tanstack/vue-query';

export const useGetUserAgentsQuery = () => {
  return useQuery({
    queryKey: ['get-user-agents-query'],
    queryFn: () => dscvrIcApi.userSettings.getUserAgents(),
  });
};
